import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { setCookie } from "../config/webStorage.js";
import { BlinkLoader } from "../components/loader";
import { BiError } from "react-icons/bi";

const LoginOtpVerificationPage = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // const params = new URLSearchParams(location.search);
    const redirectTo = location.state.redirectTo; // e.g. "/applications/123/manage"

    console.log("redirectTo:", redirectTo);
    // console.log("Location state:", location.state);

    const { email, name, rememberMe } = location.state || {};
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const verifyOtpHandler = async (e) => {
        e.preventDefault();
        if (!otp) return setError("Please enter the OTP");

        try {
            setLoading(true);
            const response = await axios.post(`${apiurl}/api/user/verifyotp`, {
                email,
                otp,
            });

            if (!response.data.success) {
                setError(response.data.message);
            } else {
                // Save token and redirect
                const token = rememberMe
                    ? response.data.refreshToken
                    : response.data.accessToken;

                setCookie("swtoken", token, rememberMe ? 2505600 : 25200);
                // navigate("/lander");
                if (redirectTo) {
  navigate(redirectTo);
} else {
  navigate("/lander");
}
            }
        } catch (error) {
            setError("OTP verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full min-h-screen flex justify-center items-center bg-[#fffdfc] p-4 md:p-10">
            <div className="w-full max-w-md border border-[#39160D] shadow-lg rounded-lg bg-white p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
                    Enter OTP
                </h2>
                <p className="text-gray-500 mb-6 text-center">
                    Hi {name}, please check your email ({email}) for the OTP.
                </p>

                <form onSubmit={verifyOtpHandler} className="space-y-4">
                    <input
                        type="text"
                        placeholder="Enter 6-digit OTP"
                        maxLength="6"
                        className="w-full px-4 py-3 bg-[#f4f2f0] focus:outline-none focus:ring-1 focus:ring-[#d8c9ae] rounded-md text-center tracking-widest text-lg"
                        value={otp}
                        onChange={(e) => {
                            setOtp(e.target.value);
                            setError("");
                        }}
                    />

                    {error && (
                        <div className="text-red-500 text-sm flex items-center gap-2">
                            <BiError /> {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="w-full bg-[#39160D] font-semibold text-[#d8c9ae] hover:bg-[#494949] h-11 flex items-center justify-center rounded-md transition duration-200"
                        disabled={loading}
                    >
                        {loading ? <BlinkLoader /> : "Verify OTP"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginOtpVerificationPage;